import { c as _c } from "react/compiler-runtime";
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { LectureId } from '../../curriculum/types/lecture-interface';
import { getLightCourseGetLecturePath } from '../light-course-api';
import { LightCourseLectureInterface } from '../light-course-interface';
export const useLightCourseLecture = lectureId => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== lectureId) {
    t1 = () => {
      if (!lectureId) {
        return null;
      }
      return [getLightCourseGetLecturePath(lectureId), RequestModuleEnum.MembershipLightCourse, RequestModuleEnum.MembershipCourseLecture];
    };
    $[1] = lectureId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    mutate
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[3] !== data || $[4] !== mutate) {
    t2 = {
      lecture: data,
      mutate
    };
    $[3] = data;
    $[4] = mutate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};